/**
 * Core Scripts
 *
 *
 *
 *
 */
import React from 'react';

import Model from './models';

import { ApiUtils, BaseAPI } from 'soxo-bootstrap-core';

class CoreScript extends BaseAPI {
    get id() {
        return 'id';
    }

    get getEndpoint() {
        return 'core-scripts';
    }

    get path() {
        return `core-scripts`;
    }

    get getName() {
        return this.modelName;
    }

    get modelName() {
        return `core-scripts`;
    }

    /* The `getPatches` method in the `CoreScript` class is a function that makes a GET request to the
   specified URL using the `ApiUtils.get` method. In this case, it is fetching data from the
   `database/patches` endpoint. This method is used to retrieve patches from the database. */
    getPatches = () => {
        return ApiUtils.get({
            url: `database/patches`,
        });
    };

    /* The `viewPatch` method in the `CoreScript` class is a function that makes a GET request to a
   specific URL using the `ApiUtils.get` method. In this case, it is fetching data from the
   `database/view-patch` endpoint with query parameters `filename` and `passKey`. The `filename` and
   `passKey` parameters are passed into the URL to specify which patch file to view based on the
   provided filename and passKey values. This method is used to view a specific patch file from the
   database by providing the necessary filename and passKey for authentication. */
    viewPatch = (filename, passKey) => {
        return ApiUtils.get({
            url: `database/view-patch?filename=${filename}&passKey=${passKey}`,
        });
    };

    /* The `executePatch` method in the `CoreScript` class is a function that makes a POST request to a
   specific URL using the `ApiUtils.post` method. In this case, it is sending data to the
   `database/sync` endpoint with the `filename` and `passKey` parameters included in the request
   body. */
    executePatch = (filename, passKey) => {
        return ApiUtils.post({
            url: 'database/sync',
            formBody: {
                filename,
                passKey,
            },
        });
    };
}
export default CoreScript;
